import { IComponentOptions } from 'angular';
import { CreditGapsWizardCtrl } from './credit-gaps-wizard.controller';

export const CreditGapsWizardComponent: IComponentOptions = {
  bindings: {
    currentSchool: '<',
    currentUser: '<',
    currentCourseDiffs: '<',
    currentFilter: '<',
  },
  controller: CreditGapsWizardCtrl,
  template: require('./credit-gaps-wizard.html'),
};
